// src/routes/AdminLanding.jsx
//
// Puerta de entrada del panel: /admin no tiene pantalla propia, solo redirige.
//
// Antes redirigía siempre a /admin/dashboard, pero el menú protege ese módulo con
// `ver('dashboard')`: un rol sin ese permiso aterrizaba en una pantalla que su
// propio menú le ocultaba, y de ahí rebotaba a /unauthorized nada más entrar.
//
// Ahora el destino se deriva del menú ya filtrado, así que la entrada y la
// navegación no pueden discrepar.
//
// Esto ordena la navegación; NO es la barrera de seguridad. La barrera son los
// `authorizeModulo` del backend.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import useAuthContext from '../hooks/useAuthContext';
import { primeraRutaDelPanel } from '../config/menuAdminConfig';

const AdminLanding = () => {
  const { user, loading } = useAuthContext();

  // Los permisos llegan en una segunda petición. Sin esta espera, la primera
  // pintada vería el mapa vacío y mandaría a /unauthorized a quien sí entra.
  if (loading || user?.permisosCargados === false) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <Spin size="large" />
          <p className="mt-4 text-gray-600">Cargando tu panel...</p>
        </div>
      </div>
    );
  }

  const destino = primeraRutaDelPanel(user);

  return <Navigate to={destino ? `/admin/${destino}` : '/unauthorized'} replace />;
};

export default AdminLanding;
